"use client";
import { useEffect } from "react";
import { addColor, removeColor } from "../ColoredSection/useColoredSection";

const ClientBackgroundColorChange = ({ color }: { color: string }) => {
  useEffect(() => {
    addColor(color);
    document.body.style.transitionDuration = "0s";
    return () => {
      removeColor();
    };
  }, [color]);
  return <></>;
};

export default ClientBackgroundColorChange;
